import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";
import { ArrowLeft, Compass, Home } from "lucide-react";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const PageNotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname,
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#FDFCFB] text-slate-900 font-sans flex flex-col antialiased">
      <Header />

      <main className="flex-1 flex items-center justify-center py-16 sm:py-32 px-4">
        <div className="max-w-md w-full text-center">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-slate-100 border border-slate-200 text-xs font-bold uppercase tracking-widest text-church-gold-700 mb-6">
            <Compass className="w-3.5 h-3.5" />
            Erreur 404
          </span>

          <h1 className="text-6xl sm:text-7xl font-black text-slate-950 tracking-tight mb-4">
            404
          </h1>

          <h2 className="text-xl sm:text-2xl font-bold text-slate-800 mb-3">
            Page introuvable
          </h2>

          <p className="text-slate-600 text-sm leading-relaxed mb-8">
            La page que vous recherchez n'existe pas ou a été déplacée. Nous
            vous invitons à retourner à la page d'accueil ou à explorer nos
            services.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-church-blue-800 hover:bg-church-blue-900 text-white font-semibold text-sm transition-all shadow-sm"
            >
              <Home className="w-4 h-4" />
              Retour à l'accueil
            </Link>
            <Link
              to="/services"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-800 font-semibold text-sm transition-all"
            >
              <ArrowLeft className="w-4 h-4" />
              Voir nos services
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PageNotFound;
